import React, { useEffect } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Dashboard as DashboardIcon,
  Add as AddIcon,
  List as ListIcon,
  Notifications as NotificationsIcon,
  PhotoLibrary as PhotoLibraryIcon,
  VpnKey as VpnKeyIcon, // Import icon for Update Password
  ExitToApp as ExitToAppIcon,
  AddLink,
} from '@mui/icons-material';

const AdminBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    switch (location.pathname) {
      case '/admin/dashboard':
        setValue(0);
        break;
      case '/admin/add-review':
        setValue(1);
        break;
      case '/admin/pending-reviews':
        setValue(2);
        break;
      case '/admin/notifications':
        setValue(3);
        break;
      case '/admin/calendly':
        setValue(4);
        break;
      case '/admin/update-password': // Add path for Update Password
        setValue(5);
        break;
      case '/admin/login':
        setValue(6);
        break;
      default:
        setValue(0);
        break;
    }
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate('/admin/dashboard');
        break;
      case 1:
        navigate('/admin/add-review');
        break;
      case 2:
        navigate('/admin/pending-reviews');
        break;
      case 3:
        navigate('/admin/notifications');
        break;
      case 4:
        navigate('/admin/calendly');
        break;
      case 5:
        navigate('/admin/update-password');
        break;
      case 6:
        console.log('Logging out...');
        localStorage.removeItem('adminToken');
        setTimeout(() => {
          // Double check removal
          if (!localStorage.getItem('adminToken')) {
            navigate('/admin/login');
          } else {
            // toast.error('Logout failed: token still present');
            alert('Logout failed: token still present');
          }
        }, 100);
        break;

      default:
        break;
    }
  };

  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
      <BottomNavigation value={value} onChange={handleChange} showLabels>
        <BottomNavigationAction label="Dashboard" value={0} icon={<DashboardIcon />} />
        <BottomNavigationAction label="Add Review" value={1} icon={<AddIcon />} />
        <BottomNavigationAction label="Pending Reviews" value={2} icon={<ListIcon />} />
        <BottomNavigationAction label="Notifications" value={3} icon={<NotificationsIcon />} />
        <BottomNavigationAction label="Calendly Link" value={4} icon={<AddLink />} />
        <BottomNavigationAction label="Update Password" value={5} icon={<VpnKeyIcon />} />
        <BottomNavigationAction label="Logout" value={6} icon={<ExitToAppIcon />} />
      </BottomNavigation>

    </Paper>
  );
};

export default AdminBottomNav;
